import { render, staticRenderFns } from "./WidgetConfigurator.vue?vue&type=template&id=26b31230&"
import script from "./WidgetConfigurator.vue?vue&type=script&lang=js&"
export * from "./WidgetConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports